import script from "./TournamentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TournamentsView.vue?vue&type=script&setup=true&lang=ts"

import "./TournamentsView.vue?vue&type=style&index=0&id=6429830b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6429830b"]])

export default __exports__